var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11497_46532)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M2.87179 0H53.1282C54.7143 0 56 1.28945 56 2.88V33.12C56 34.7106 54.7143 36 53.1282 36H2.87179C1.28577 36 0 34.7106 0 33.12V2.88C0 1.28945 1.28577 0 2.87179 0Z",
    fill: "#0E4595"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M21.0503 25.1086L23.4454 11.0139H27.2764L24.8795 25.1086H21.0503ZM38.7197 11.3177C37.9608 11.0322 36.7714 10.7258 35.2864 10.7258C31.501 10.7258 28.8345 12.6374 28.8119 15.3772C28.7904 17.4025 30.7155 18.5324 32.1684 19.2066C33.6597 19.8974 34.1609 20.338 34.1539 20.9549C34.1445 21.8997 32.9631 22.3313 31.862 22.3313C30.3287 22.3313 29.5141 22.1177 28.256 21.5914L27.7623 21.3675L27.2246 24.5228C28.1194 24.9162 29.7741 25.257 31.492 25.2747C35.519 25.2747 38.133 23.3849 38.1629 20.4591C38.1772 18.8558 37.1566 17.6356 34.9464 16.6296C33.6074 15.9777 32.7874 15.5425 32.7961 14.8823C32.7961 14.2964 33.4902 13.6699 34.9899 13.6699C36.2427 13.6505 37.1502 13.9244 37.8572 14.2099L38.2005 14.3726L38.7197 11.3177ZM48.5778 11.0137H45.6176C44.7006 11.0137 44.0143 11.2647 43.6116 12.1825L37.9223 25.0993H41.945C41.945 25.0993 42.6027 23.3625 42.7514 22.9812C43.1912 22.9812 47.0989 22.9873 47.6577 22.9873C47.7723 23.4807 48.1236 25.0993 48.1236 25.0993H51.6785L48.5778 11.0132V11.0137ZM43.8839 20.1041C44.2006 19.292 45.4102 16.164 45.4102 16.164C45.3876 16.2016 45.7246 15.348 45.9181 14.8188L46.1769 16.034C46.1769 16.034 46.9105 19.3985 47.0638 20.1041H43.8839ZM17.8051 11.0161L14.0546 20.6281L13.6549 18.6748C12.9567 16.4231 10.7813 13.9836 8.34937 12.7623L11.7787 25.0887L15.832 25.0841L21.863 11.016H17.8051",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M10.5481 11.0132H4.37079L4.3219 11.3065C9.12771 12.4731 12.3076 15.2926 13.628 18.68L12.2847 12.2029C12.0528 11.3104 11.3803 11.0441 10.5482 11.0129",
    fill: "#F2AE14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11497_46532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d2eba186cfaab3ee93f5ea85b02e38b4.svg";
export { ForwardRef as ReactComponent };